/**
 * Feature flags that are monitored for analytics purposes.
 * This constant is used as the single source of truth for analytics feature flag defaults.
 */
export const watchedFlags = {
  'growth.ecomm.telemetry.event-kill-switch.operational': {},
  'growth.ecomm.platform.gtm-data-layer-v2': false,
} as const;

export const GTM_V2_FLAG = 'growth.ecomm.platform.gtm-data-layer-v2' as const;

export type AnalyticsFeatureFlags = Record<keyof typeof watchedFlags, any>;
